const stickers = {
  'stickers-breadcrumbs': 'Stickers',
  'stickers-details-title': 'Sticker',
  'stickers-filter-title': 'Filter stickers',
  'stickers-create-sidebar': 'Create sticker',
  'stickers-preview-title': 'Sticker preview',
  'stickers-unpublish-used-notification': 'Unable to unpublish a sticker attached to an event',
  'structures-source-stickers': 'Stickers',
  'structures-source-sticker': 'Sticker',
};

export default stickers;
